// GENERATED by scripts/index-anatomy.mjs — do not edit. Measured from app/public/anatomy/*.glb.
// Which anatomical part lives in which avatar layer, and where (figure space). See anatomyLandmarks.ts.
const ANATOMY_INDEX = {
 "generatedAt": "2026-10-11",
 "convention": "figure space: body 1.6 units tall, feet y=-0.75, head ≈ +0.85; part positions use patient-RIGHT = +x (the resolver flips x for the renderer)",
 "tolerance": 0.05,
 "fit": {
  "source": "skin",
  "scale": 0.929967,
  "centerX": 0,
  "centerZ": 0.003243875914627284,
  "minY": -0.0029636782128363848
 },
 "layers": {
  "skin": {
   "file": "skin.glb",
   "meshCount": 281,
   "bbox": {
    "min": [
     -0.32,
     -0.75,
     -0.133
    ],
    "max": [
     0.32,
     0.85,
     0.133
    ]
   }
  },
  "muscle": {
   "file": "muscles.glb",
   "meshCount": 4,
   "bbox": {
    "min": [
     -0.311,
     -0.741,
     -0.124
    ],
    "max": [
     0.311,
     0.841,
     0.125
    ]
   }
  },
  "vascular": {
   "file": "vessels.glb",
   "meshCount": 2,
   "bbox": {
    "min": [
     -0.309,
     -0.744,
     -0.099
    ],
    "max": [
     0.309,
     0.835,
     0.124
    ]
   }
  },
  "organs": {
   "file": "organs.glb",
   "meshCount": 29,
   "bbox": {
    "min": [
     -0.122,
     -0.072,
     -0.081
    ],
    "max": [
     0.121,
     0.697,
     0.096
    ]
   }
  },
  "skeletal": {
   "file": "skeleton.glb",
   "meshCount": 2,
   "bbox": {
    "min": [
     -0.311,
     -0.739,
     -0.108
    ],
    "max": [
     0.311,
     0.839,
     0.125
    ]
   }
  },
  "nerves": {
   "file": "nerves.glb",
   "meshCount": 105,
   "bbox": {
    "min": [
     -0.31,
     -0.741,
     -0.104
    ],
    "max": [
     0.31,
     0.834,
     0.118
    ]
   }
  }
 },
 "parts": {
  "eyes": {
   "layer": "nerves",
   "pos": [
    0,
    0.732,
    0.055
   ],
   "sideOffsetX": 0.028,
   "source": "measured",
   "meshes": [
    "Object_89",
    "Object_90"
   ],
   "nearestMesh": "Object_47",
   "nearestDist": 0,
   "verified": true,
   "note": "paired globes, head height, anterior"
  },
  "brain": {
   "layer": "nerves",
   "pos": [
    0,
    0.781,
    -0.005
   ],
   "source": "measured",
   "meshes": [
    "Object_50"
   ],
   "nearestMesh": "Object_39",
   "nearestDist": 0,
   "verified": true
  },
  "heart": {
   "layer": "vascular",
   "pos": [
    -0.04,
    0.38,
    0.06
   ],
   "source": "authored",
   "nearestMesh": "Object_2",
   "nearestDist": 0,
   "verified": true,
   "note": "heart & great vessels are part of the circulatory model"
  },
  "septum": {
   "layer": "vascular",
   "pos": [
    -0.03,
    0.4,
    0.06
   ],
   "source": "authored",
   "nearestMesh": "Object_2",
   "nearestDist": 0,
   "verified": true
  },
  "arteries": {
   "layer": "vascular",
   "pos": [
    0,
    0.34,
    -0.02
   ],
   "source": "authored",
   "nearestMesh": "Object_2",
   "nearestDist": 0,
   "verified": true,
   "note": "descending aorta"
  },
  "lungs": {
   "layer": "organs",
   "pos": [
    0.07,
    0.45,
    0.04
   ],
   "sideOffsetX": 0.07,
   "source": "authored",
   "nearestMesh": "Object_2",
   "nearestDist": 0,
   "verified": true
  },
  "thyroid": {
   "layer": "organs",
   "pos": [
    0,
    0.52,
    0.06
   ],
   "source": "authored",
   "nearestMesh": "Object_2",
   "nearestDist": 0,
   "verified": true
  },
  "liver": {
   "layer": "organs",
   "pos": [
    0.08,
    0.3,
    0.05
   ],
   "source": "authored",
   "nearestMesh": "Object_49",
   "nearestDist": 0,
   "verified": true
  },
  "spleen": {
   "layer": "organs",
   "pos": [
    -0.09,
    0.31,
    0
   ],
   "source": "authored",
   "nearestMesh": "Object_53",
   "nearestDist": 0,
   "verified": true
  },
  "pancreas": {
   "layer": "organs",
   "pos": [
    -0.04,
    0.27,
    -0.01
   ],
   "source": "authored",
   "nearestMesh": "Object_51",
   "nearestDist": 0,
   "verified": true
  },
  "kidney": {
   "layer": "organs",
   "pos": [
    0.08,
    0.28,
    -0.05
   ],
   "sideOffsetX": 0.08,
   "source": "authored",
   "nearestMesh": "Object_53",
   "nearestDist": 0,
   "verified": true
  },
  "bladder": {
   "layer": "organs",
   "pos": [
    0,
    0.06,
    0.05
   ],
   "source": "authored",
   "nearestMesh": "Object_51",
   "nearestDist": 0,
   "verified": true
  },
  "spine": {
   "layer": "skeletal",
   "pos": [
    0,
    0.36,
    -0.075
   ],
   "source": "authored",
   "nearestMesh": "Object_2",
   "nearestDist": 0,
   "verified": true,
   "note": "vertebral column; level → y is interpolated in the resolver"
  },
  "psoas": {
   "layer": "muscle",
   "pos": [
    0.06,
    0.17,
    -0.02
   ],
   "sideOffsetX": 0.06,
   "source": "authored",
   "nearestMesh": "Object_2",
   "nearestDist": 0,
   "verified": true
  },
  "paraspinal": {
   "layer": "muscle",
   "pos": [
    0.03,
    0.36,
    -0.04
   ],
   "sideOffsetX": 0.03,
   "source": "authored",
   "nearestMesh": "Object_2",
   "nearestDist": 0,
   "verified": true
  },
  "trunk": {
   "layer": "skin",
   "pos": [
    0,
    0.22,
    0.1
   ],
   "source": "authored",
   "nearestMesh": "Object_27",
   "nearestDist": 0,
   "verified": true,
   "note": "body composition / weight"
  }
 }
} as const;
export default ANATOMY_INDEX;
